import { createContext } from 'react'

export const ServerSeoContext = createContext(false)

const META_SELECTOR = [
  'meta[name="description"]', 'meta[name="robots"]',
  'meta[property^="og:"]', 'meta[property^="product:"]',
  'meta[name^="twitter:"]', 'link[rel="canonical"]',
  'script[type="application/ld+json"][data-storefront-seo]',
].join(',')

export function clearSeo(): void {
  document.head.querySelectorAll(META_SELECTOR).forEach((node) => node.remove())
  const robots = document.createElement('meta')
  robots.name = 'robots'
  robots.content = 'noindex, follow'
  document.head.appendChild(robots)
}

export function applySeo(html: string): void {
  const parsed = new DOMParser().parseFromString(html, 'text/html')
  if (!parsed.querySelector('link[rel="canonical"]')) throw new Error('Invalid SEO response')
  clearSeo()
  document.head.querySelector('meta[name="robots"]')?.remove()
  document.title = parsed.title
  parsed.head.querySelectorAll(META_SELECTOR).forEach((node) => {
    // Only inert metadata is copied. Analytics/other executable scripts are excluded.
    document.head.appendChild(document.importNode(node, true))
  })
}
